
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _400nXinuWCnwbXaZs5Fxd8Bvo9FzXLNT1W9v0jTQlMR5RIMeta } from "/opt/build/repo/domains/core/pages/400.vue?macro=true";
import { default as _4014ArVz3GTOhpBztB4wIj7ToKB2D89motj214kE49_JLwMeta } from "/opt/build/repo/domains/core/pages/401.vue?macro=true";
import { default as _4032bwS6BTmJW_45SahbMB7cNEY1bIvHb7m8Qum5v77Qe1w0Meta } from "/opt/build/repo/domains/core/pages/403.vue?macro=true";
import { default as _404FkvJYN2RR2_DK1I6DUQ7N7pM8KJl0dY5VeySMLfPtAEMeta } from "/opt/build/repo/domains/core/pages/404.vue?macro=true";
import { default as _500xF7TE5f1siBnPEZIyZ5iugifPB2Zl3jioKBLFZ69yOsMeta } from "/opt/build/repo/domains/core/pages/500.vue?macro=true";
import { default as cartIP836adtdOdqJfUXxgjuqj_K_AM56u4UsKMPCcmts8gMeta } from "/opt/build/repo/domains/checkout/pages/cart.vue?macro=true";
import { default as index7mIea3qh1PlVb4QKSTZbaesVuWKGVqBS0SUG6KpT_45FoMeta } from "/opt/build/repo/domains/commerce/pages/help/index.vue?macro=true";
import { default as deliveryMSxmaDKFPo6_pM2nd0HaE04j0PuP3O1zBbIoT40ZRs0Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/help/delivery.vue?macro=true";
import { default as warrantyFuDgTJMO7RxjRfgiq0RReafKVtsG0nOqlVkLY2WMeLAMeta } from "/opt/build/repo/brands/thenorthface/pages/help/warranty.vue?macro=true";
import { default as all_45topicsvRuvM99ruYTyVKp_vFCObRsYTg8b9cRhmy5UWx2kzxsMeta } from "/opt/build/repo/domains/commerce/pages/help/all-topics.vue?macro=true";
import { default as contact_45usqSRckMeDE33LsgLiz8AM_DtrAlfM_45zyR_maoi8xhRnQMeta } from "/opt/build/repo/domains/commerce/pages/help/contact-us.vue?macro=true";
import { default as index_45Ozbnrjx_S3U_45qm5prUuvnUat9SJ7QVpU9IanjO95_sMeta } from "/opt/build/repo/domains/commerce/pages/help/[slug]/index.vue?macro=true";
import { default as how_45to_45returnrPGVtha0KCYBfmt_nF53_45qMMuZZxuQ4DR6pMB3977z8Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/help/returns/how-to-return.vue?macro=true";
import { default as size_45chartsjcuMmpcb6QCiPeC__hlR6rjgtgXRgy_hBgDLcj3fCgYMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/help/product-info/size-charts.vue?macro=true";
import { default as indexcro7bVMs9gKA35N0ihDM5eJP2DXwLAd2e4tbxuTSYEwMeta } from "/opt/build/repo/domains/commerce/pages/help/[slug]/[child_slug]/index.vue?macro=true";
import { default as helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta } from "/opt/build/repo/domains/commerce/pages/help.vue?macro=true";
import { default as eventsmSWHTAQYKOIDtwrWpJy8uKdfk4Tveh9CvlkgUON4QFkMeta } from "/opt/build/repo/brands/thenorthface/pages/events.vue?macro=true";
import { default as outlet_klHThi3ZsyefbmMLmbWF0jEd_RupCEsTYqov0DA510Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/outlet.vue?macro=true";
import { default as indexRxbhi3LU3GDDPAR9_45HKIRzgNgrgFbIB_452Dooq_45hA69cMeta } from "/opt/build/repo/domains/commerce/pages/search/index.vue?macro=true";
import { default as articlesU3f3HsiLilRr7HfOFYCCGZKw2icYjpwWas3PoXnMPzAMeta } from "/opt/build/repo/domains/commerce/pages/search/articles.vue?macro=true";
import { default as searchRO4tzUI4tmQBu_aNiG_tC0A3rxzZdSwXd5dYKSaVXWkMeta } from "/opt/build/repo/domains/commerce/pages/search.vue?macro=true";
import { default as indexhiDGsdtSRHe2vqICrY_C72_T3t9PXh17y_453qDDQVSkAMeta } from "/opt/build/repo/domains/commerce/pages/account/index.vue?macro=true";
import { default as loyalty3wNgiXUTZcRzY6wOPRzn7Jb9JINQ7TWnPl3GaMZCwIMMeta } from "/opt/build/repo/domains/commerce/pages/account/loyalty.vue?macro=true";
import { default as profilensxEhguA_WrIl6Feo5MtRQsp4n7gkf2ZhDSSOPc_45uEsMeta } from "/opt/build/repo/domains/commerce/pages/account/profile.vue?macro=true";
import { default as gift_45cardspwqYZSwO3HvJ5J_45g8C_yx9p3XU_49Tqr9444vNTfDjUMeta } from "/opt/build/repo/domains/commerce/pages/account/gift-cards.vue?macro=true";
import { default as indexG4bEWsxomlrMoXHZrwmechQEtcW0uYVIlfY7raPPpFAMeta } from "/opt/build/repo/domains/commerce/pages/account/address/index.vue?macro=true";
import { default as order_45historyn0rHoVGIMKe8lFacDQN_IJbKqRgzXUbwHX_45SpjTllMIMeta } from "/opt/build/repo/domains/commerce/pages/account/order-history.vue?macro=true";
import { default as addWedzaMZiySLZIG4sxQ5UBSoLlkUBTZMmb_45ku6UOmJ54Meta } from "/opt/build/repo/domains/commerce/pages/account/credit-cards/add.vue?macro=true";
import { default as indexTKl2R4M2EWtMECFcOG4z6dH3nE90_JnSE9uLumN4pzAMeta } from "/opt/build/repo/domains/commerce/pages/account/credit-cards/index.vue?macro=true";
import { default as _91_46_46_46id_93nJh8mAEyj0vyqA5yWL2OKjERt1pZ9RxjcUqH_sHSsa0Meta } from "/opt/build/repo/domains/commerce/pages/account/order-details/[...id].vue?macro=true";
import { default as add_45billing_45address8kfEdc6QJE8Q3nb9nr69CiAo34ALO4dMKLlRfnPo_60Meta } from "/opt/build/repo/domains/commerce/pages/account/address/add-billing-address.vue?macro=true";
import { default as add_45shipping_45addressrmVdSgo4lNpctayrCpkqLftE_45XxOxr1yKDXZiB16qk8Meta } from "/opt/build/repo/domains/commerce/pages/account/address/add-shipping-address.vue?macro=true";
import { default as account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta } from "/opt/build/repo/domains/commerce/pages/account.vue?macro=true";
import { default as sign_45inU9qLdxmychjW0749cQjyNd9nXpwrQ_wZcKzTpjldOiEMeta } from "/opt/build/repo/domains/commerce/pages/sign-in.vue?macro=true";
import { default as basecamp2_dshgTTM8GYupmGWgVKeF5sBpZEORyedLnm7Qjc0ekMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/basecamp.vue?macro=true";
import { default as buy_45backGz0OS_45j3uBx8yE_RMccnTz0BvI8gmMykbF26qP2hAIcMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/buy-back.vue?macro=true";
import { default as checkoutC4D34fjqFoVWqFQXlH8kfYWPu_45KWXO2U9_45iMnfF3lqIMeta } from "/opt/build/repo/domains/checkout/pages/checkout.vue?macro=true";
import { default as _91_46_46_46slug_93CrMFLkWbvVSiu0B9By5os_RsavVX2AgsroDUT_45TVRYwMeta } from "/opt/build/repo/domains/content/pages/[...slug].vue?macro=true";
import { default as earth_45dayCEPwZlkchKkdY5cNZX0daiEdTAxd3H1ZnIAzKji8WkwMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/earth-day.vue?macro=true";
import { default as favoritesONyPSTVmnbSJpmPYRXJidDor1wJSa4PwH2IkuggGxakMeta } from "/opt/build/repo/domains/commerce/pages/favorites.vue?macro=true";
import { default as gift_45cardWnAIjMVwSqjNmrWtwfJDVWPepjV3RLWLQoeinbs6a2oMeta } from "/opt/build/repo/domains/commerce/pages/gift-card.vue?macro=true";
import { default as our_45socksFkDV1S4keS_dIEiOK5r2hYI5B7E9D7rH95cpymOlXugMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/our-socks.vue?macro=true";
import { default as take_45backOn3aPkpJTYtk3oBODfqcCcsDM1aVjgoqH_5rs890sFcMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/take-back.vue?macro=true";
import { default as lower_45envsGva5dXm0sUdFEmvA3dbTcKFaQbJLUXZxYspbheLHck4Meta } from "/opt/build/repo/domains/core/pages/lower-envs.vue?macro=true";
import { default as size_45chartzkbOxfBx4qP_5TQivfBEla1g1Kz10ko2RWF6n5dcyssMeta } from "/opt/build/repo/domains/commerce/pages/size-chart.vue?macro=true";
import { default as frame1aSq_45MaS2HDfGNywXSkE_45CmCw_iZYPBIGgqFcUaenCsMeta } from "/opt/build/repo/domains/commerce/pages/soci/frame.vue?macro=true";
import { default as storeipadsXPtLVCiEAYHGrpQ7DtEfdSfA3mEmn2oE6dgfI9PN4bYMeta } from "/opt/build/repo/brands/thenorthface/pages/storeipads.vue?macro=true";
import { default as _91_46_46_46slug_93EbK_vwv_l52SPLMC0fpbEeQDmT7O6fnDpyfDb6dFsqcMeta } from "/opt/build/repo/domains/commerce/pages/c/[...slug].vue?macro=true";
import { default as previewgT0SgvGgzxM32iVtPDlGsYEeL2DkQDkQKXFfkb64mgAMeta } from "/opt/build/repo/domains/content/pages/cms/preview.vue?macro=true";
import { default as _91_46_46_46slug_93sS_evXxzVeC_459iV85ESlWiWgprFUbbxSDUpIql4S_KsMeta } from "/opt/build/repo/domains/commerce/pages/p/[...slug].vue?macro=true";
import { default as footerX44fL7pRNXwlmfhOZtBOvJUrLf94cvbG2VCFt6KjR94Meta } from "/opt/build/repo/domains/commerce/pages/soci/footer.vue?macro=true";
import { default as headerd3qY4igJYSD2pbxrvQmLpl7TfwNc5AQgrLVokWMCE1cMeta } from "/opt/build/repo/domains/commerce/pages/soci/header.vue?macro=true";
import { default as order_45statuseng1bXoqVdZnkohFGOT_ZRQ_45Aunrz5i1gsBnoReHjvsMeta } from "/opt/build/repo/domains/commerce/pages/order-status.vue?macro=true";
import { default as return_45labelOejPaVcBEY8HeKLKvU94gqJgABWmpfQ4l1B6O7gP2ZEMeta } from "/opt/build/repo/domains/commerce/pages/return-label.vue?macro=true";
import { default as jacket_45finderEdus_45cEmOysYf7Sd__45ixtiIAW2XbHMqEjFEAjQ4EeT8Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/jacket-finder.vue?macro=true";
import { default as order_45detailsqZnQ8UGlraBim57iOR6Wi_L8uIHbpaKm_HubgRf7JZgMeta } from "/opt/build/repo/domains/commerce/pages/order-details.vue?macro=true";
import { default as store_45locatorfbrq3Wd1WulVeEpmn_y4mD3iic0hpxoU7u_aGgNDSroMeta } from "/opt/build/repo/domains/commerce/pages/store-locator.vue?macro=true";
import { default as summit_45seriesS3mJYEPNjPm_beYUOg22rMRJLO6rSZfUZNQjtoC7MPAMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/summit-series.vue?macro=true";
import { default as amazon_45sign_45in0_hypGUbXCFbpT45MYvEjUGMLXKF8aC5ws16o7Ao5eEMeta } from "/opt/build/repo/domains/commerce/pages/amazon-sign-in.vue?macro=true";
import { default as _91slug_939LxE3vfEtujoHiFy0IcriP1BjbWDeFKB8L13Zp1JBxIMeta } from "/opt/build/repo/brands/thenorthface/pages/explore/[slug].vue?macro=true";
import { default as repair_45servicexSt5ru5jZEYnMAiIkPMoibL1CFT8CJoOB_45yFZxuf2dYMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/repair-service.vue?macro=true";
import { default as reset_45password5V_454JzMUKSBahZIhy5iJTFfwBZCQEB9BJhWbfpKatwoMeta } from "/opt/build/repo/domains/commerce/pages/reset-password.vue?macro=true";
import { default as social_45sign_45inNbReRTvQAi_45gceRen0yRFWFrGnUK5zz8_45_45auA7LmtiEMeta } from "/opt/build/repo/domains/commerce/pages/social-sign-in.vue?macro=true";
import { default as write_45a_45review1y8sosMpLbcS8Q9CYsTVx0SXLV2EfFLjr0hLzj7BenAMeta } from "/opt/build/repo/domains/commerce/pages/write-a-review.vue?macro=true";
import { default as amktechnologiesahBa3ubpQ_45J4x5CnhZCUmUY_kHglw4eyY5WQtIZascIMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/amktechnologies.vue?macro=true";
import { default as _91slug_93y49ZUZFzrU66JoQ5dZaf_IkUQkH9_728j6_B_i3M_45jEMeta } from "/opt/build/repo/domains/commerce/pages/articles/[slug].vue?macro=true";
import { default as backpack_45finderXviPuENDJORBaDjcbgj3LMyRNr4yvAXZlcsKsWOqzyQMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/backpack-finder.vue?macro=true";
import { default as footwear_45finder6I3waOS4piBCwl1okDDkymCr5l2VxpiWuII3CC_90dgMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/footwear-finder.vue?macro=true";
import { default as forgot_45passwordZVSP4Gj80jzBVxmWiK43LwinAZ07Mpk4axaYbgLk9_45MMeta } from "/opt/build/repo/domains/commerce/pages/forgot-password.vue?macro=true";
import { default as index21UI1h1AVSgnuKirKdTfoVhASrhgspM_45xOWKaa7MvXoMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/index.vue?macro=true";
import { default as product_45bundlesk0qz5dK9rwa8_mrdbcypKAd0qiPN0_xmEl2H6rqLC04Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/product-bundles.vue?macro=true";
import { default as historyGZTz7rgH8bq0XSV_45tUxVjqGkq23lbZuK0rBccp9uCEgMeta } from "/opt/build/repo/brands/thenorthface/pages/about-us/history.vue?macro=true";
import { default as faqRcxNRx6JYI_45qGH9JM5J8Bqz_45C4QZpA_45KOlKWiuR8wzEMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/help-section/faq.vue?macro=true";
import { default as denaliPGpD8V_Gz5YauEG09FMszaWLZdGZ3R9_45WQUtBGCUHVcMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/denali.vue?macro=true";
import { default as nuptseSh3W8Xv9Umhk_aWaUdHVDx8xqZoDC2_45sfVXhvDpTcxwMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/nuptse.vue?macro=true";
import { default as student_45discount73noHw9IAIJhiVZtv7XhKn5NPctXYhxQf0RTwT7S7mIMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/student-discount.vue?macro=true";
import { default as indexV4B9eX1cl5cKvRem_cAEF2CKVG8CUHA9VFoQ_3xcL_UMeta } from "/opt/build/repo/domains/core/pages/healthcheck/index.vue?macro=true";
import { default as mocksZVKZB7WOQCI_jPUqDbeA6yfCjux2UADwAFNk8M1FjdwMeta } from "/opt/build/repo/domains/core/pages/healthcheck/mocks.vue?macro=true";
import { default as location_45selectoruqLqoewvfbQiJh3XlRldlZt7EdDCHIWNDCuDY11AoYwMeta } from "/opt/build/repo/domains/commerce/pages/location-selector.vue?macro=true";
import { default as loyalty_45programme80PK2KLcjDSpwqrdiS1M2CUQyf7nEpio_45dwB8Fd5SykMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/loyalty-programme.vue?macro=true";
import { default as indexGAafnNS1rzieX5FAoLiKdvwrdGFOmh4nHfaGw2sNaTUMeta } from "/opt/build/repo/domains/content/pages/sandbox/cms/index.vue?macro=true";
import { default as summit_45series_45kit0GLvlZEYK_450m5ooromMdBrXBdQ1rXItuNyrD1P7VVPUMeta } from "/opt/build/repo/brands/thenorthface/pages/summit-series-kit.vue?macro=true";
import { default as splitCZmeTn22XMqu8E3XE1btCyKFraULprQk5lP2eftDHjIMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/split.vue?macro=true";
import { default as explore_45collection4p9hvBuw0yM1la4qI0sYsUeG8w8QRYR69Fw07bzW_45OAMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/explore-collection.vue?macro=true";
import { default as statuszrHGVQBp0KWb_dV15we2P3SeZPQdpeTG3iVki8CBfF4Meta } from "/opt/build/repo/domains/core/pages/healthcheck/status.vue?macro=true";
import { default as newsletter_45sign_45upPryMDpw7NUiLiwo1IQWmAqXc58LjWcpNhzdEWXdy8G0Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/newsletter-sign-up.vue?macro=true";
import { default as order_45confirmationezXCszUm20wBSoH9gEsKRPFxOQOWlW9lS709b0IbazAMeta } from "/opt/build/repo/domains/checkout/pages/order-confirmation.vue?macro=true";
import { default as run_45for_45the_45arctici9noQFR4v5MVe4fmvgEbKOmw2fM1X_45FSSO2I2uNPNsgMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/run-for-the-arctic.vue?macro=true";
import { default as shoe_45finder_45retailc83zi8ZJz0NpfEgP_Ebbx5ZT164FRQi3cvlNJ_W9Xx8Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/shoe-finder-retail.vue?macro=true";
import { default as triclimate_45jacketshmFGHcI8G8LaieQc1Zx2W7XD7J6ZfMRl4CJ0fQtcnKoMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/triclimate-jackets.vue?macro=true";
import { default as singlekivaXphvI_45xjWtJXWb8EP6_45kyuhXQhiG9mZgvZcVHJkMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/single.vue?macro=true";
import { default as viewerEq2MpXIuVkPkNABg4b64rG7cmF3Zb3XdR3OBFi3ZG6kMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/viewer.vue?macro=true";
import { default as _91productId_93Zae_kquWzBWBEcyvwNdI1L41FELno9Qd7gD890BhSuMMeta } from "/opt/build/repo/domains/commerce/pages/reviews/[productId].vue?macro=true";
import { default as sitemapshYe80GseAi05MHEKQeFAvZg4_45XowIxUCEqgRJ7SvhIsMeta } from "/opt/build/repo/domains/core/pages/healthcheck/sitemaps.vue?macro=true";
import { default as ipad_45qr_45registrationlDUYP6wzRrpsPEYmHGbisYAf71vzNYCyNOtLlKfrUksMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/ipad-qr-registration.vue?macro=true";
import { default as in_45store_45registrationCaPHlu_458_Bm_45Uw7kf83IH9mdO_45OUPLVXDTreExHRgMMMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/in-store-registration.vue?macro=true";
import { default as indexy0zU_45IYBHh39fz8J8rTi3aFevijvP8TegUtudtmKmYIMeta } from "/opt/build/repo/domains/content/pages/sandbox/dialogs/index.vue?macro=true";
import { default as index72pH0pc09oH5iYB2mJHS_rGR8eTSgUz5EKoHhKW0UwYMeta } from "/opt/build/repo/domains/content/pages/sandbox/monetate/index.vue?macro=true";
import { default as summit_45series_45footwearY3S6crooqcBvt8uvXttbsgAcrPxWuUmeLffwa5JFuPIMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/summit-series-footwear.vue?macro=true";
import { default as tent_45sleepingbag_45guideLKZs2HQT34_044U02Dh9H1yqWbnL9OabLGIut5Yi6_IMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/tent-sleepingbag-guide.vue?macro=true";
import { default as experiments6qbyACBWNmWPnV_45_45apu98dRknBGSrBo9y8Hkj6WB3B4Meta } from "/opt/build/repo/domains/core/pages/healthcheck/experiments.vue?macro=true";
import { default as static_45pagesMx9rhWDKZc8W_ohSfghSSKROP3BZJZF7ako9gF1GrN8Meta } from "/opt/build/repo/domains/core/pages/healthcheck/static-pages.vue?macro=true";
import { default as translationscEY0wkIrJ0SyiL38JqfZLb9D_453zQUWB7HyQikvr2sbkMeta } from "/opt/build/repo/domains/core/pages/healthcheck/translations.vue?macro=true";
import { default as checkout4977_oSYx_45KkdBASNOMgaA6iXiukHnrMBCiE2Ud8y6cMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/checkout.vue?macro=true";
import { default as _91productId_93ZZv7WtSOGL4FJN33mtZJo4pOKuw9iNsIFpY1qg8DDRwMeta } from "/opt/build/repo/domains/commerce/pages/find-in-store/[productId].vue?macro=true";
import { default as feature_45flagsGBdTz8454P8O9IuSxO2DxwDKR2TogiLoaCYxaiklJGUMeta } from "/opt/build/repo/domains/core/pages/healthcheck/feature-flags.vue?macro=true";
import { default as shoe_45finder_45retail_45vectivzp4BBy0ZvXyfqXmm_45HJcSL_45NimOdQ0UZEjYyZqMOuJgMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/shoe-finder-retail-vectiv.vue?macro=true";
import { default as base_45camp_45duffelTTYi4nvRhdjJMz6MJghA034zhq_3fQdbcjog_NROCl8Meta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/base-camp-duffel.vue?macro=true";
import { default as vectiv5WVOa1kjobPvf4_45d2y8qbafHgSyjXPqfYOQ9FPDZI8IMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/innovation/technologies/vectiv.vue?macro=true";
import { default as order_45shipment_45trackerG4zRtZ_jckRdFGc7t8Lz97C54Ou7TlXTq6LeD8GXOZEMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/order-shipment-tracker.vue?macro=true";
import { default as xplr_45pass_45registration_45qr_45codegQ1JZF7JzG6l2wGMzzOdSBsDopc4Bki2G1jVBPZMO3MMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/xplr-pass-registration-qr-code.vue?macro=true";
import { default as profile5owZybaWWjhlFsQIndADBH7YlGVAzjVUaOALQ_45LWKcIMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/account/profile.vue?macro=true";
import { default as hilaree_45nelsonULARaef3r8M1bJFjum6FR1bJMAhLfixJvPouv1gcV18Meta } from "/opt/build/repo/brands/thenorthface/pages/about-us/athletes/hilaree-nelson.vue?macro=true";
import { default as dashboardRZixJzfWRPjqRr1LT21kVDXVKMN9vkgmbOfUTAZEwg8Meta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/account/dashboard.vue?macro=true";
import { default as order_45confirmationEK9aP7Mdxb7Ri0vCc0_459SmdNAhDnudR83VB9cLubHhoMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/order-confirmation.vue?macro=true";
import { default as declaration_45of_45conformityWmDcjlpNUYI4nMGk4Xe6jN_q6OFyw7x85O_xScO1oDoMeta } from "/opt/build/repo/brands/thenorthface/regions/emea/pages/help-section/terms-and-conditions/declaration-of-conformity.vue?macro=true";
export default [
  {
    name: "400",
    path: "/400",
    meta: _400nXinuWCnwbXaZs5Fxd8Bvo9FzXLNT1W9v0jTQlMR5RIMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/400.vue")
  },
  {
    name: "401",
    path: "/401",
    meta: _4014ArVz3GTOhpBztB4wIj7ToKB2D89motj214kE49_JLwMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/401.vue")
  },
  {
    name: "403",
    path: "/403",
    meta: _4032bwS6BTmJW_45SahbMB7cNEY1bIvHb7m8Qum5v77Qe1w0Meta || {},
    component: () => import("/opt/build/repo/domains/core/pages/403.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404FkvJYN2RR2_DK1I6DUQ7N7pM8KJl0dY5VeySMLfPtAEMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/404.vue")
  },
  {
    name: "500",
    path: "/500",
    meta: _500xF7TE5f1siBnPEZIyZ5iugifPB2Zl3jioKBLFZ69yOsMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/500.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/build/repo/domains/checkout/pages/cart.vue")
  },
  {
    name: helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta?.name,
    path: "/help",
    meta: helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/help.vue"),
    children: [
  {
    name: "help",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/index.vue")
  },
  {
    name: "help-delivery",
    path: "delivery",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/help/delivery.vue")
  },
  {
    name: "help-warranty",
    path: "warranty",
    component: () => import("/opt/build/repo/brands/thenorthface/pages/help/warranty.vue")
  },
  {
    name: "help-all-topics",
    path: "all-topics",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/all-topics.vue")
  },
  {
    name: "help-contact-us",
    path: "contact-us",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/contact-us.vue")
  },
  {
    name: "help-slug",
    path: ":slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/[slug]/index.vue")
  },
  {
    name: "help-returns-how-to-return",
    path: "returns/how-to-return",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/help/returns/how-to-return.vue")
  },
  {
    name: "help-product-info-size-charts",
    path: "product-info/size-charts",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/help/product-info/size-charts.vue")
  },
  {
    name: "help-slug-child_slug",
    path: ":slug()/:child_slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/[slug]/[child_slug]/index.vue")
  }
]
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/opt/build/repo/brands/thenorthface/pages/events.vue")
  },
  {
    name: "outlet",
    path: "/outlet",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/outlet.vue")
  },
  {
    name: "search-parent",
    path: "/search",
    meta: { ...(searchRO4tzUI4tmQBu_aNiG_tC0A3rxzZdSwXd5dYKSaVXWkMeta || {}), ...{"middleware":"plp-store-filter"} },
    component: () => import("/opt/build/repo/domains/commerce/pages/search.vue"),
    children: [
  {
    name: "search",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/search/index.vue")
  },
  {
    name: "search-articles",
    path: "articles",
    component: () => import("/opt/build/repo/domains/commerce/pages/search/articles.vue")
  }
]
  },
  {
    name: account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta?.name,
    path: "/account",
    meta: account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/account.vue"),
    children: [
  {
    name: "account",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/index.vue")
  },
  {
    name: "account-loyalty",
    path: "loyalty",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/loyalty.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/profile.vue")
  },
  {
    name: "account-gift-cards",
    path: "gift-cards",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/gift-cards.vue")
  },
  {
    name: "account-address",
    path: "address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/index.vue")
  },
  {
    name: "account-order-history",
    path: "order-history",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/order-history.vue")
  },
  {
    name: "account-credit-cards-add",
    path: "credit-cards/add",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/credit-cards/add.vue")
  },
  {
    name: "account-credit-cards",
    path: "credit-cards",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/credit-cards/index.vue")
  },
  {
    name: "account-order-details-id",
    path: "order-details/:id(.*)*",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/order-details/[...id].vue")
  },
  {
    name: "account-address-add-billing-address",
    path: "address/add-billing-address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/add-billing-address.vue")
  },
  {
    name: "account-address-add-shipping-address",
    path: "address/add-shipping-address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/add-shipping-address.vue")
  }
]
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inU9qLdxmychjW0749cQjyNd9nXpwrQ_wZcKzTpjldOiEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sign-in.vue")
  },
  {
    name: "basecamp",
    path: "/basecamp",
    meta: basecamp2_dshgTTM8GYupmGWgVKeF5sBpZEORyedLnm7Qjc0ekMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/basecamp.vue")
  },
  {
    name: "buy-back",
    path: "/buy-back",
    meta: buy_45backGz0OS_45j3uBx8yE_RMccnTz0BvI8gmMykbF26qP2hAIcMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/buy-back.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutC4D34fjqFoVWqFQXlH8kfYWPu_45KWXO2U9_45iMnfF3lqIMeta || {},
    component: () => import("/opt/build/repo/domains/checkout/pages/checkout.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93CrMFLkWbvVSiu0B9By5os_RsavVX2AgsroDUT_45TVRYwMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/[...slug].vue")
  },
  {
    name: "earth-day",
    path: "/earth-day",
    meta: earth_45dayCEPwZlkchKkdY5cNZX0daiEdTAxd3H1ZnIAzKji8WkwMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/earth-day.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/opt/build/repo/domains/commerce/pages/favorites.vue")
  },
  {
    name: "gift-card",
    path: "/gift-card",
    component: () => import("/opt/build/repo/domains/commerce/pages/gift-card.vue")
  },
  {
    name: "our-socks",
    path: "/our-socks",
    meta: our_45socksFkDV1S4keS_dIEiOK5r2hYI5B7E9D7rH95cpymOlXugMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/our-socks.vue")
  },
  {
    name: "take-back",
    path: "/take-back",
    meta: take_45backOn3aPkpJTYtk3oBODfqcCcsDM1aVjgoqH_5rs890sFcMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/take-back.vue")
  },
  {
    name: "lower-envs",
    path: "/lower-envs",
    meta: lower_45envsGva5dXm0sUdFEmvA3dbTcKFaQbJLUXZxYspbheLHck4Meta || {},
    component: () => import("/opt/build/repo/domains/core/pages/lower-envs.vue")
  },
  {
    name: "size-chart",
    path: "/size-chart",
    meta: size_45chartzkbOxfBx4qP_5TQivfBEla1g1Kz10ko2RWF6n5dcyssMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/size-chart.vue")
  },
  {
    name: "soci-frame",
    path: "/soci/frame",
    meta: frame1aSq_45MaS2HDfGNywXSkE_45CmCw_iZYPBIGgqFcUaenCsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/frame.vue")
  },
  {
    name: "storeipads",
    path: "/storeipads",
    meta: storeipadsXPtLVCiEAYHGrpQ7DtEfdSfA3mEmn2oE6dgfI9PN4bYMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/pages/storeipads.vue")
  },
  {
    name: "c-slug",
    path: "/c/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93EbK_vwv_l52SPLMC0fpbEeQDmT7O6fnDpyfDb6dFsqcMeta || {}), ...{"middleware":"plp-store-filter"} },
    component: () => import("/opt/build/repo/domains/commerce/pages/c/[...slug].vue")
  },
  {
    name: "cms-preview",
    path: "/cms/preview",
    meta: previewgT0SgvGgzxM32iVtPDlGsYEeL2DkQDkQKXFfkb64mgAMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/preview.vue")
  },
  {
    name: "p-slug",
    path: "/p/:slug(.*)*",
    meta: _91_46_46_46slug_93sS_evXxzVeC_459iV85ESlWiWgprFUbbxSDUpIql4S_KsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/p/[...slug].vue")
  },
  {
    name: "soci-footer",
    path: "/soci/footer",
    meta: footerX44fL7pRNXwlmfhOZtBOvJUrLf94cvbG2VCFt6KjR94Meta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/footer.vue")
  },
  {
    name: "soci-header",
    path: "/soci/header",
    meta: headerd3qY4igJYSD2pbxrvQmLpl7TfwNc5AQgrLVokWMCE1cMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/header.vue")
  },
  {
    name: "order-status",
    path: "/order-status",
    meta: order_45statuseng1bXoqVdZnkohFGOT_ZRQ_45Aunrz5i1gsBnoReHjvsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/order-status.vue")
  },
  {
    name: "return-label",
    path: "/return-label",
    meta: return_45labelOejPaVcBEY8HeKLKvU94gqJgABWmpfQ4l1B6O7gP2ZEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/return-label.vue")
  },
  {
    name: "jacket-finder",
    path: "/jacket-finder",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/jacket-finder.vue")
  },
  {
    name: "order-details",
    path: "/order-details",
    meta: order_45detailsqZnQ8UGlraBim57iOR6Wi_L8uIHbpaKm_HubgRf7JZgMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/order-details.vue")
  },
  {
    name: "store-locator",
    path: "/store-locator",
    component: () => import("/opt/build/repo/domains/commerce/pages/store-locator.vue")
  },
  {
    name: "summit-series",
    path: "/summit-series",
    meta: summit_45seriesS3mJYEPNjPm_beYUOg22rMRJLO6rSZfUZNQjtoC7MPAMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/summit-series.vue")
  },
  {
    name: "amazon-sign-in",
    path: "/amazon-sign-in",
    component: () => import("/opt/build/repo/domains/commerce/pages/amazon-sign-in.vue")
  },
  {
    name: "explore-slug",
    path: "/explore/:slug()",
    component: () => import("/opt/build/repo/brands/thenorthface/pages/explore/[slug].vue")
  },
  {
    name: "repair-service",
    path: "/repair-service",
    meta: repair_45servicexSt5ru5jZEYnMAiIkPMoibL1CFT8CJoOB_45yFZxuf2dYMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/repair-service.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password5V_454JzMUKSBahZIhy5iJTFfwBZCQEB9BJhWbfpKatwoMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/reset-password.vue")
  },
  {
    name: "social-sign-in",
    path: "/social-sign-in",
    component: () => import("/opt/build/repo/domains/commerce/pages/social-sign-in.vue")
  },
  {
    name: "write-a-review",
    path: "/write-a-review",
    component: () => import("/opt/build/repo/domains/commerce/pages/write-a-review.vue")
  },
  {
    name: "amktechnologies",
    path: "/amktechnologies",
    meta: amktechnologiesahBa3ubpQ_45J4x5CnhZCUmUY_kHglw4eyY5WQtIZascIMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/amktechnologies.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/articles/[slug].vue")
  },
  {
    name: "backpack-finder",
    path: "/backpack-finder",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/backpack-finder.vue")
  },
  {
    name: "footwear-finder",
    path: "/footwear-finder",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/footwear-finder.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/opt/build/repo/domains/commerce/pages/forgot-password.vue")
  },
  {
    name: "our-icons",
    path: "/our-icons",
    meta: index21UI1h1AVSgnuKirKdTfoVhASrhgspM_45xOWKaa7MvXoMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/index.vue")
  },
  {
    name: "product-bundles",
    path: "/product-bundles",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/product-bundles.vue")
  },
  {
    name: "about-us-history",
    path: "/about-us/history",
    meta: historyGZTz7rgH8bq0XSV_45tUxVjqGkq23lbZuK0rBccp9uCEgMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/pages/about-us/history.vue")
  },
  {
    name: "help-section-faq",
    path: "/help-section/faq",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/help-section/faq.vue")
  },
  {
    name: "our-icons-denali",
    path: "/our-icons/denali",
    meta: denaliPGpD8V_Gz5YauEG09FMszaWLZdGZ3R9_45WQUtBGCUHVcMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/denali.vue")
  },
  {
    name: "our-icons-nuptse",
    path: "/our-icons/nuptse",
    meta: nuptseSh3W8Xv9Umhk_aWaUdHVDx8xqZoDC2_45sfVXhvDpTcxwMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/nuptse.vue")
  },
  {
    name: "student-discount",
    path: "/student-discount",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/student-discount.vue")
  },
  {
    name: "healthcheck",
    path: "/healthcheck",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/index.vue")
  },
  {
    name: "healthcheck-mocks",
    path: "/healthcheck/mocks",
    meta: mocksZVKZB7WOQCI_jPUqDbeA6yfCjux2UADwAFNk8M1FjdwMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/mocks.vue")
  },
  {
    name: "location-selector",
    path: "/location-selector",
    meta: location_45selectoruqLqoewvfbQiJh3XlRldlZt7EdDCHIWNDCuDY11AoYwMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/location-selector.vue")
  },
  {
    name: "loyalty-programme",
    path: "/loyalty-programme",
    meta: loyalty_45programme80PK2KLcjDSpwqrdiS1M2CUQyf7nEpio_45dwB8Fd5SykMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/loyalty-programme.vue")
  },
  {
    name: "sandbox-cms",
    path: "/sandbox/cms",
    component: () => import("/opt/build/repo/domains/content/pages/sandbox/cms/index.vue")
  },
  {
    name: "summit-series-kit",
    path: "/summit-series-kit",
    meta: summit_45series_45kit0GLvlZEYK_450m5ooromMdBrXBdQ1rXItuNyrD1P7VVPUMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/pages/summit-series-kit.vue")
  },
  {
    name: "cms-showcase-split",
    path: "/cms/showcase/split",
    meta: splitCZmeTn22XMqu8E3XE1btCyKFraULprQk5lP2eftDHjIMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/split.vue")
  },
  {
    name: "explore-collection",
    path: "/explore-collection",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/explore-collection.vue")
  },
  {
    name: "healthcheck-status",
    path: "/healthcheck/status",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/status.vue")
  },
  {
    name: "newsletter-sign-up",
    path: "/newsletter-sign-up",
    meta: newsletter_45sign_45upPryMDpw7NUiLiwo1IQWmAqXc58LjWcpNhzdEWXdy8G0Meta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/newsletter-sign-up.vue")
  },
  {
    name: "order-confirmation",
    path: "/order-confirmation",
    meta: order_45confirmationezXCszUm20wBSoH9gEsKRPFxOQOWlW9lS709b0IbazAMeta || {},
    component: () => import("/opt/build/repo/domains/checkout/pages/order-confirmation.vue")
  },
  {
    name: "run-for-the-arctic",
    path: "/run-for-the-arctic",
    meta: run_45for_45the_45arctici9noQFR4v5MVe4fmvgEbKOmw2fM1X_45FSSO2I2uNPNsgMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/run-for-the-arctic.vue")
  },
  {
    name: "shoe-finder-retail",
    path: "/shoe-finder-retail",
    meta: shoe_45finder_45retailc83zi8ZJz0NpfEgP_Ebbx5ZT164FRQi3cvlNJ_W9Xx8Meta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/shoe-finder-retail.vue")
  },
  {
    name: "triclimate-jackets",
    path: "/triclimate-jackets",
    meta: triclimate_45jacketshmFGHcI8G8LaieQc1Zx2W7XD7J6ZfMRl4CJ0fQtcnKoMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/triclimate-jackets.vue")
  },
  {
    name: "cms-showcase-single",
    path: "/cms/showcase/single",
    meta: singlekivaXphvI_45xjWtJXWb8EP6_45kyuhXQhiG9mZgvZcVHJkMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/single.vue")
  },
  {
    name: "cms-showcase-viewer",
    path: "/cms/showcase/viewer",
    meta: viewerEq2MpXIuVkPkNABg4b64rG7cmF3Zb3XdR3OBFi3ZG6kMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/viewer.vue")
  },
  {
    name: "reviews-productId",
    path: "/reviews/:productId()",
    meta: _91productId_93Zae_kquWzBWBEcyvwNdI1L41FELno9Qd7gD890BhSuMMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/reviews/[productId].vue")
  },
  {
    name: "healthcheck-sitemaps",
    path: "/healthcheck/sitemaps",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/sitemaps.vue")
  },
  {
    name: "ipad-qr-registration",
    path: "/ipad-qr-registration",
    meta: ipad_45qr_45registrationlDUYP6wzRrpsPEYmHGbisYAf71vzNYCyNOtLlKfrUksMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/ipad-qr-registration.vue")
  },
  {
    name: "in-store-registration",
    path: "/in-store-registration",
    meta: in_45store_45registrationCaPHlu_458_Bm_45Uw7kf83IH9mdO_45OUPLVXDTreExHRgMMMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/in-store-registration.vue")
  },
  {
    name: "sandbox-dialogs",
    path: "/sandbox/dialogs",
    component: () => import("/opt/build/repo/domains/content/pages/sandbox/dialogs/index.vue")
  },
  {
    name: "sandbox-monetate",
    path: "/sandbox/monetate",
    component: () => import("/opt/build/repo/domains/content/pages/sandbox/monetate/index.vue")
  },
  {
    name: "summit-series-footwear",
    path: "/summit-series-footwear",
    meta: summit_45series_45footwearY3S6crooqcBvt8uvXttbsgAcrPxWuUmeLffwa5JFuPIMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/summit-series-footwear.vue")
  },
  {
    name: "tent-sleepingbag-guide",
    path: "/tent-sleepingbag-guide",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/tent-sleepingbag-guide.vue")
  },
  {
    name: "healthcheck-experiments",
    path: "/healthcheck/experiments",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/experiments.vue")
  },
  {
    name: "healthcheck-static-pages",
    path: "/healthcheck/static-pages",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/static-pages.vue")
  },
  {
    name: "healthcheck-translations",
    path: "/healthcheck/translations",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/translations.vue")
  },
  {
    name: "sandbox-preview-checkout",
    path: "/sandbox/preview/checkout",
    meta: checkout4977_oSYx_45KkdBASNOMgaA6iXiukHnrMBCiE2Ud8y6cMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/checkout.vue")
  },
  {
    name: "find-in-store-productId",
    path: "/find-in-store/:productId()",
    meta: _91productId_93ZZv7WtSOGL4FJN33mtZJo4pOKuw9iNsIFpY1qg8DDRwMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/find-in-store/[productId].vue")
  },
  {
    name: "healthcheck-feature-flags",
    path: "/healthcheck/feature-flags",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/feature-flags.vue")
  },
  {
    name: "shoe-finder-retail-vectiv",
    path: "/shoe-finder-retail-vectiv",
    meta: shoe_45finder_45retail_45vectivzp4BBy0ZvXyfqXmm_45HJcSL_45NimOdQ0UZEjYyZqMOuJgMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/shoe-finder-retail-vectiv.vue")
  },
  {
    name: "our-icons-base-camp-duffel",
    path: "/our-icons/base-camp-duffel",
    meta: base_45camp_45duffelTTYi4nvRhdjJMz6MJghA034zhq_3fQdbcjog_NROCl8Meta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/our-icons/base-camp-duffel.vue")
  },
  {
    name: "innovation-technologies-vectiv",
    path: "/innovation/technologies/vectiv",
    meta: vectiv5WVOa1kjobPvf4_45d2y8qbafHgSyjXPqfYOQ9FPDZI8IMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/innovation/technologies/vectiv.vue")
  },
  {
    name: "sandbox-order-shipment-tracker",
    path: "/sandbox/order-shipment-tracker",
    meta: order_45shipment_45trackerG4zRtZ_jckRdFGc7t8Lz97C54Ou7TlXTq6LeD8GXOZEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/order-shipment-tracker.vue")
  },
  {
    name: "xplr-pass-registration-qr-code",
    path: "/xplr-pass-registration-qr-code",
    meta: xplr_45pass_45registration_45qr_45codegQ1JZF7JzG6l2wGMzzOdSBsDopc4Bki2G1jVBPZMO3MMeta || {},
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/xplr-pass-registration-qr-code.vue")
  },
  {
    name: "sandbox-preview-account-profile",
    path: "/sandbox/preview/account/profile",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/account/profile.vue")
  },
  {
    name: "about-us-athletes-hilaree-nelson",
    path: "/about-us/athletes/hilaree-nelson",
    component: () => import("/opt/build/repo/brands/thenorthface/pages/about-us/athletes/hilaree-nelson.vue")
  },
  {
    name: "sandbox-preview-account-dashboard",
    path: "/sandbox/preview/account/dashboard",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/account/dashboard.vue")
  },
  {
    name: "sandbox-preview-order-confirmation",
    path: "/sandbox/preview/order-confirmation",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/order-confirmation.vue")
  },
  {
    name: "help-section-terms-and-conditions-declaration-of-conformity",
    path: "/help-section/terms-and-conditions/declaration-of-conformity",
    component: () => import("/opt/build/repo/brands/thenorthface/regions/emea/pages/help-section/terms-and-conditions/declaration-of-conformity.vue")
  }
]